module.exports = __webpack_public_path__ + "static/media/controler.bec30001.jpg";